import React, { useState } from "react";
import { Ticket } from "../../../models/Ticket";
import "./style.scss";
import "../../../../style/MyAccount-ticket/universal-line-vertical.scss";
import { HiOutlineArrowRight, HiOutlineTicket, HiQrcode } from "react-icons/hi";
import format from "date-fns/format";
import ModalComponent from "../../../../features/ModalComponent";
import QrCodeModal from "../../../../features/QRcode";
import SingleExercise from "./singleExerciseDesktop";
import { useSelector } from "react-redux";
import { State } from "../../../store";
import SelectPassModalFooter from "./selectPassModalFooter";
import { useTranslation } from "react-i18next";
import EAButton from "../../shared/Buttons/EAButton";
import useBasketManager from "../../FinalizePage/hooks/useBasketManager";
import { useNavigate } from "react-router-dom";
import { FINALIZE_PAGE } from "../../../routes";

interface IProps {
  ticket: Ticket;
  index: number;
  getSelect: () => void;
  changeDeafultView: (value: number) => void;
}
const SelectPassMobile: React.FC<IProps> = ({ ticket, getSelect, index, changeDeafultView }: IProps) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [assignedList, setAssignedList] = useState(false);
  const { prolongPass } = useBasketManager();
    const navigate = useNavigate();
    const finalizeFunction = () => {
        setTimeout(() => {
          navigate(FINALIZE_PAGE);
        }, 600);
      
    };
  const newValidTo = new Date(ticket.validto);
  newValidTo.setDate(newValidTo.getDate() + 1);


  const allowReservationByPassOnFitnessPlan = useSelector(
    (state: State) => state.config.configuration.allowReservationByPassOnFitnessPlan
  );

  return (
    <React.Fragment>
      {(ticket.passtype === 2 || ticket.passtype === 3) && ticket.ticket === false && (
        <div className="purchased-assort-mobile">
          <div className="purchased-assort-mobile__title">
            <div className="purchased-assort-mobile__title__startIcon">
              <HiOutlineTicket />
            </div>
            <h5>{ticket.name}</h5>
          </div>

          <div className="purchased-assort-mobile__line"></div>
          <div className="purchased-assort-mobile__body">
            <div className="purchased-assort-mobile__body__detal">
              <HiOutlineArrowRight className="icon" />
              {t("wazny_od")}: {format(ticket.validfrom, "dd.MM.yyyy")}r.
            </div>
            <div className="purchased-assort-mobile__body__detal">
              <HiOutlineArrowRight className="icon" />
              {t("wazny_do")}: {format(ticket.validto, "dd.MM.yyyy")}r.
            </div>
            <div className="purchased-assort-mobile__body__detal">
              <HiOutlineArrowRight className="icon" />

              {ticket.entrances - ticket.exercises.length > 200 ? (
                <b>
                  {t("pozostalo")}: bez limitu wejść {t("wejsc")}
                </b>
              ) : (
                <b>
                  {" "}
                  {t("pozostalo")}: {ticket.entrances - ticket.exercises.length} {t("wejsc")}
                </b>
              )}
            </div>
          </div>


          {ticket.extendAllowed && (
            <EAButton title={t("przedluz_karnet")} onClick={() => {prolongPass(ticket.assortIds, 1, newValidTo); finalizeFunction()}}  variant="filled" fullWidth />
          )}




          <div className="purchased-assort-mobile__action">
            <EAButton title={t("pokaz_terminy")} onClick={() => setAssignedList(!open)} variant="outlined" fullWidth />

            <EAButton title={t("pokaz_kod_qr")} onClick={() => setOpen(!open)} fullWidth endIcon={<HiQrcode />} />
          </div>
        </div>
      )}

      {open && (
        <ModalComponent
          footer={false}
          open={open}
          closeModal={() => setOpen(false)}
          title={t("kod_qr")}
          leftType="exercise"
          onAccept={() => setOpen(false)}
        >
          <QrCodeModal trhId={ticket.trhId} name={ticket.name} />
          <EAButton title={t("gotowe_schowaj")} onClick={() => setOpen(!open)} fullWidth />
        </ModalComponent>
      )}

      {assignedList && (
        <ModalComponent
          footer={false}
          open={assignedList}
          closeModal={() => setAssignedList(false)}
          title={t("najblizsze_rezerwacje")}
          onAccept={() => setAssignedList(false)}
        >
          <React.Fragment>
            {/* <SelectPassBar ticket={ticket} /> */}

            {ticket.exercises[0] && (
              <div>
                {ticket.exercises.map((exercise, index) => (
                  <div key={index}>
                    <SingleExercise exercise={exercise} getSelect={getSelect} />
                  </div>
                ))}
              </div>
            )}

            {allowReservationByPassOnFitnessPlan && <SelectPassModalFooter ticket={ticket} />}
          </React.Fragment>
        </ModalComponent>
      )}
    </React.Fragment>
  );
};

export default SelectPassMobile;
